import { useQuery } from "react-query";
import { getProducerCodeByEmpId } from "../../../../../actions/Employees";

export const useGetProucerCodeByEmpId = (employeeId) => {
  return useQuery(
    ["GetProducerCodeByEmpId", employeeId],
    () => getProducerCodeByEmpId(employeeId),
    { refetchOnWindowFocus: false }
  );
};
